import cn from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{text: ['12', '14', '16', '18', '20', '28', '32']}],
            pt: [{pt: ['app']}],
            pb: [{pb: ['app', 'app-menu']}],
        },
        conflictingClassGroups: {
            pt: ['pt'],
            pb: ['pb'],
        },
    },
});

export const twx = (...props: Parameters<typeof cn>) => twMerge(cn(props));
